<template>
    <div class="left" id="cisViewPort">
        <LoadingSpinner v-if="loadIndicatorVisible" />
        <DxToast v-model:visible="isToastVisible"
                 v-model:message="toastMessage"
                 @hiding="toastHiding"
                 :displayTime="4000"
                 maxWidth="80%">
        </DxToast>
        <div id="lgi ">
            <div class="lgi-header">
                <div @click="toLandingPage()" class="pq4-logo">
                </div>
                <div class="lgi-welcome">
                    Activate account <i class="fas fa-lock"></i>
                </div>
            </div>

            <div class="LoginBody">
                <div v-if="tokenValid" class="field">
                    <div class="LoginPassword">
                        Password:
                    </div>
                    <div class="LoginBoxLeft">
                        <div class="InputBox">
                            <input type="password" class="LoginBox ID_UserName" v-model="record.pwd1">
                            <password-meter :password="record.pwd1" />
                        </div>
                        <div class="pwd-rule" v-if="!pwdValid">
                            {{pwdRuleMsg}}
                        </div>
                    </div>
                    <div class="LoginPassword">
                        Confirm password:
                    </div>
                    <div class="LoginBoxRight">
                        <div class="InputBox">
                            <input type="password" class="LoginBox ID_PassWord" v-model="record.pwd2">
                            <div class="pwd-rule" v-if="!pwdDiff">
                                Please confirm the password!
                            </div>
                        </div>
                    </div>
                    <div class="LoginBoxButton">
                        <DxButton text="Activate account"
                                  type="success"
                                  :disabled="!pwdCorrect"
                                  styling-mode="contained"
                                  @click="SetPassword()" />
                    </div>
                </div>
                <div class="LoginErrorMsg">
                    <div v-if="falseTokenMessageVisible">
                        <p>
                            {{ tx.ActivateAccountTitle }}
                        </p>
                        <p>
                            {{ tx.ActivateAccountMessage }}
                        </p>
                    </div>
                    <div v-if="hasServerError">
                        <p>
                            {{ ActivateAccountErrorMessage }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import { DxToast } from 'devextreme-vue/toast';
    import axios from 'axios'
    import $ from 'jquery'
    import { DxButton } from 'devextreme-vue/button';
    import passwordMeter from "vue-simple-password-meter";
    import { alert } from "devextreme/ui/dialog";
    const baseUri = "WebApi.asmx/api/user";
    export default {
        name: 'ActivateNewAccount',
        components: {
            passwordMeter, DxButton, DxToast, LoadingSpinner
        },
        data() {
            return {
                tx: {
                    ActivateAccountTitle: this.$LanguageProvider.GetResource("ActivateAccountTitle", "Title", "The Activation Code is Invalid"),
                    ActivateAccountMessage: this.$LanguageProvider.GetResource("ActivateAccountMessage", "Message", "Either the activation link has already been used or it has expired."),
                    ActivateAccountErrorMessage: this.$LanguageProvider.GetResource("ActivateAccountErrorMessage", "Message", "Activation has failed due to a server error."),
                },
                isToastVisible: false,
                toastMessage: '',
                loadIndicatorVisible: false,
                falseTokenMessageVisible: false,
                hasServerError: false,
                pwdRuleMsg: "",
                pwdRule: "",
                record: {
                    pwd1: "",
                    pwd2: ""
                }
            };
        },
        computed: {
            topicTypeList() {
                return this.$store.state.createTopicStore.topicTypeList
            },
            createTopicDisabled() {
                return this.tty == null || this.tty == {}
            },
            rc() {
                return this.$route.query.rc
            },
            tokenValid() {
                return !this.$data.falseTokenMessageVisible
            },
            pwdValid() {
                return RegExp(this.$data.pwdRule).test(this.$data.record.pwd1)
            },
            pwdDiff() {
                const rec = this.$data.record
                return !(rec.pwd1.length > 1 && rec.pwd1 != rec.pwd2)
            },
            pwdCorrect() {
                return this.record.pwd1 == this.record.pwd2 && this.pwdValid && this.tokenValid
            }
        },
        mounted: function () {
            this.validateToken()
        },
        methods: {
            validateToken() {
                this.loadIndicatorVisible = true
                axios
                    .get(baseUri + '/ValidateActivationToken?RC=' + this.rc)
                    .then(res => {
                        this.loadIndicatorVisible = false
                        if (res.data.success == false) {
                            this.$data.falseTokenMessageVisible = true
                        }
                        else {
                            this.$data.pwdRuleMsg = res.data.pwdRuleMsg
                            this.$data.pwdRule = res.data.pwdRule
                        }
                    })
            },
            SetPassword() {
                this.loadIndicatorVisible = true
                var formData = new FormData()
                formData.append("RC", this.rc)
                formData.append("Password", this.record.pwd1)
                axios
                    .post(baseUri + '/ActivateByToken', formData)
                    .then(res => {
                        if (res.data.success == false) {
                            this.loadIndicatorVisible = false
                            this.$data.hasServerError = true
                            alert("A unknown error occured", "Activate Account")
                        }
                        else {
                            this.toastMessage = "Your account has been successfully activated. You can now log in with the password you have chosen.";
                            this.isToastVisible = true;
                        }
                    })
            },
            toastHiding() {
                this.loadIndicatorVisible = true
                $("form").attr("action", "../Login.aspx").submit();
            }
        }
    }
</script>
<style scoped>
    input.activateButton {
        text-align: center;
        padding: 6px 16px;
        color: var(--bg-color1);
    }

    .field {
        display: grid;
        grid-gap: 10px;
    }

    input.LoginBox {
        width: 100%;
        border-width: 0px;
        background-color: #e8f0fe;
        padding: 15px;
        box-sizing: border-box;
    }

        input.LoginBox:focus {
            outline: none;
        }

    .pq4-logo {
        height: 85px;
    }

    .dx-loadindicator-wrapper.dx-loadindicator-image {
        animation: loadindicator 1s linear infinite;
    }

    @keyframes loadindicator {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .dx-loadpanel-content-wrapper * {
        display: inherit;
    }

    .po-password-strength-bar {
        margin-top: -5px;
        margin-bottom: 10px;
    }

    .dx-loadindicator {
        width: 45px;
        height: 45px;
        display: inline-block;
        overflow: hidden;
        border: none;
        background-color: transparent;
    }

    .LoginBoxButton {
        margin-top: 20px;
        display: grid;
    }

    .pwd-rule {
        color: red;
        margin-left: 10px;
        display: inline-block;
        font-size: 11px;
        margin-bottom: 10px;
    }

    .ButtonDisabled .art-button-wrapper .art-button-l, .ButtonDisabled .art-button-wrapper .art-button-r {
        opacity: .4;
    }
</style>
